import React, { FC, useState, MouseEvent } from 'react'
import { useDispatch } from 'react-redux'
import List, { ListItem } from '@bt-react/components/List'
import Icon, { IconType } from '@bt-react/components/Icon'
import styles from './LayoutsSelectPresenter.module.scss'
import classnames from 'classnames'
import { setAutoSpotlight, setFocus } from '../../../dataStore/actions/room/room'
import { LayoutsSelectPresenterProps } from './types'

const LayoutsSelectPresenter: FC<LayoutsSelectPresenterProps> = ({ presenters, autoSpotlight, focusedPresenterID }) => {

  const [ menuOpen, setMenuOpen ] = useState(false)
  const dispatch = useDispatch<any>()

  const handleMenuToggle = () => setMenuOpen(!menuOpen)
  const handleMenuBlur = () => setMenuOpen(false)


  const onListItemClick = (e: MouseEvent, presenterID?: string) => {
    e.preventDefault()
    if (presenterID) dispatch(setFocus(presenterID))
    dispatch(setAutoSpotlight(presenterID ? false : true))
    setMenuOpen(false)
  }

  return (
    <div
      data-bdd={'layouts-select-presenter'}
      className={classnames({
          [styles['layouts-select-presenter-container--open']]: menuOpen
        },
        styles['layouts-select-presenter-container']
      )}>
      <button
        data-bdd={`layouts-select-presenter-button`}
        className={styles['layouts-select-presenter-button']}
        onClick={handleMenuToggle}
        onBlur={handleMenuBlur}
      >
        {
            menuOpen ?
            <><Icon colour={IconType.colour.white} name={IconType.iconName.angleLeft} />  Current presenter</> :
            <><Icon colour={IconType.colour.white} name={IconType.iconName.podium} />  Select presenter</>
        }
      </button>
      <List
        dataBdd={`layouts-select-presenter-list`}
        className={styles['layouts-select-presenter-list']}
        separated={false}>
          <>
            <ListItem
              dataBdd={`layouts-select-presenter-list-item--auto-spotlight`}
              className={classnames({
                  [styles['layouts-select-presenter-list-item--highlighted']]: autoSpotlight
                },
                styles['layouts-select-presenter-list-item'])}
              separated={true}
              content={
                <span className={styles['layouts-select-presenter-list-item-span']}>
                  <Icon colour={IconType.colour.white} name={IconType.iconName.usersClass} /> Auto spotlight
                </span>
              }
              onMouseDown={e => onListItemClick(e)}
            />
            {
              presenters.map(presenter =>
                <ListItem
                  dataBdd={`layouts-select-presenter-list-item--presenter`}
                  className={classnames({
                      [styles['layouts-select-presenter-list-item--highlighted']]: !autoSpotlight && focusedPresenterID === presenter.BTID
                    },
                    styles['layouts-select-presenter-list-item'])
                  }
                  key={presenter.BTID}
                  separated={true}
                  content={
                    <span className={styles['layouts-select-presenter-list-item-span']}>
                      <Icon colour={IconType.colour.white} name={IconType.iconName.user} /> {presenter.name}
                    </span>
                  }
                  onMouseDown={e => onListItemClick(e, presenter.BTID)}
                />
              )
            }
          </>
      </List>
    </div>
  )
}

export default LayoutsSelectPresenter